import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";
import { loadLanguage } from "../../../../../../../utils";

const defultPhotoBoothDta = {
    "Name": "Your Name",
    "Enter_Name": "Enter Your Name",
    "Email": "Your Email",
    "Enter_Email": "Enter Your Email ID",
    "UGC": "Add a Caption",
    "Write_caption": "What's happening at this moment?",
    "Agreeing": "By clicking on Submit, you are agreeing to our",
    "TnC": "terms and conditions"
}

const PreviewSection = ({ title, subTitle, btnText, termsConditions, logoImg, IMGCOMP = null, tab, placeholders, onsite_language, allLang, backgroundImg, language }) => {
    const isReview = tab == 1;
    //const Lang = useMemo(() => !tab ? defultPhotoBoothDta : allLang?.[onsite_language] || allLang?.english || {}, [allLang, onsite_language]);

    const [Lang, setlang] = useState(null);

    useEffect(() => {
        const fetchLang = async () => {
            const langData = await loadLanguage(language, onsite_language);
            setlang(langData);
        };
         fetchLang();
    }, [language || onsite_language]);

    

        return (<div className="f-center flex-wrap snapUpContainer d-flex justify-content-center" style={{backgroundImage: `url(${backgroundImg})`, backgroundSize: 'cover', backgroundPosition: 'center'}} >
                <div className="onsite_preview_inner w-100">
                    <div className="t_modal_wrap h-100" >
                        <div className="t_modal_container h-100 position-relative">
                            <div className="t_modal_content rounded bg-white shadow h-100 d-flex flex-column justify-content-center">
                            {logoImg ? <div className="t_m_logo_w">
                                <img loading="lazy" src={logoImg} className="t_m_logo" height="45" alt="logo" />
                            </div> : null}
                                {title ? <div className="t_m_title">{title.length > 0 ? title : placeholders.title}</div> : null}
                                {subTitle ? <div className="t_m_subtitle">{subTitle.length > 0 ? subTitle : placeholders.subTitle}</div> : null}
                                {IMGCOMP ? <div className="text-center">{IMGCOMP}</div> : null}
                                {isReview ? <div className="t_f_group">
                                    <div className="t_label_ t_label_center">Rate the Product <div className="t_t_danger">*</div></div>
                                    <div className="t_rate_wrap d-flex align-items-center justify-content-center">
                                    {[...Array(5)].map((number, index) => <div key={index} className={`t_star_ico_wrap ${index < 4 ? 't_h_active_' :''}`}>
                                        <div className="t_star_ico w-44px h-44px f-center">
                                            <FontAwesomeIcon type={`${index < 4 ? 'solid' : 'regular'}`} icon={'star-sharp'} iconClass={'fs-2'} />
                                        </div>
                                    </div>)}
                                    </div>
                                </div> : null}
                                <div className="t_f_group">
                                    <div className="t_label_">{isReview ? Lang?.Review : Lang?.UGC}<div className="t_t_danger">*</div></div>
                                    <textarea className="t_from_textarea" placeholder={`${isReview ? Lang?.Write_review : Lang?.Write_caption}`} readOnly></textarea>
                                </div>
                                {IMGCOMP ? null : <div className="t_f_group">
                                    <div className="t_f_upload d-flex align-items-center flex-wrap">
                                        <div className="t_m_upload t_m_dd">
                                            <div className="t_m_up_wrp">
                                                <div className="uppy-Container">
                                                    <div className="uppy-Root" dir="ltr">
                                                    <div className="uppy-u-reset">
                                                        <div className="uppy-DragDrop-inner">
                                                                <div className="uppy-DragDrop-label">{Lang?.Drag_video}</div>
                                                                <span className="uppy-DragDrop-note">{Lang?.Video_size}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div className="t_f_group">
                                            <div className="t_label_">{Lang?.Name}<div className="t_t_danger">*</div></div>
                                            <input type="text" className="t_from_input " placeholder={Lang?.Enter_Name} value="" readOnly/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="t_f_group">
                                            <div className="t_label_ text-nowrap">{Lang?.Email} <div className="t_t_danger">*</div></div>
                                            <input type="text" className="t_from_input " placeholder={Lang?.Enter_Email } value="" readOnly/>
                                        </div>
                                    </div>
                                </div>
                                <div className="t_f_group mb-4">
                                    <div className="t_f_check_inline"><input type="checkbox" id="t_accept" className="t_from_check" value="accept" checked=""/><label className="t_check_label_ mb-0" for="t_accept">{Lang?.Agreeing} <a href={termsConditions} className="t_tc_link" target="_blank">{Lang?.TnC}</a> *</label></div>
                                </div>
                                <div className="t_f_group text-center mb-0">
                                    <div className="btn btn-dark p-3 w-100 rounded text-white cursor-pointer text-center text-capitalize outline-none ">{btnText ? btnText : placeholders.btnText}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );

    } 

export default PreviewSection;